"use client";

import React from "react";
import { Loader } from "lucide-react";

const Loading = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-300">
      <Loader className="animate-spin text-primary" />
    </div>
  );
};

export default Loading;
